/**
 * @description 公用 API
 */
const prefix = process.env.VUE_APP_API_DATAS
export default ({ request }) => ({
  // 页面banner
  pagesBanner(params = {}) {
    return request({
      url: `${prefix}/pagesBanner`,
      method: 'get',
      params
    })
  },
  // 页面banner
  settings(params = {}) {
    return request({
      url: `${prefix}/settings`,
      method: 'get',
      params
    })
  },
})
